import React from "react";
import { Box } from "@mui/material";
import PortfolioSummaryTable from "./PortfolioSummaryTable";
import PortfolioTabs from "./PortfolioTabs";
import BenchMarkTable from "../VantageSystem/BenchMarkTable";

const PortfolioMainContent = ({
  titleText,
  longShortLabels,
  totals,
  onToggleGridViewSummary,
  value,
  onChange,
  onPositionPerformanceClick,
  livePrices,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 3,
        mb: 3,
      }}
    >
       <Box sx={{ width: "50%", marginRight: 0, padding: "0px" }}>
        <PortfolioSummaryTable
          titleText={titleText}
          longShortLabels={longShortLabels}
          totals={totals}
          onToggleGridViewSummary={onToggleGridViewSummary}
        />
        <PortfolioTabs
          value={value}
          onChange={onChange}
          onPositionPerformanceClick={onPositionPerformanceClick}
        />
      </Box>
      <Box sx={{ width: "50%", marginRight: 0, padding: "0px" }}>
        <BenchMarkTable marketData={livePrices} />
      </Box>
    </Box>
  );
};

export default PortfolioMainContent;
